export default {
  unitCoordinates: null,
  clientesAtivosCoordinates: null,
  clientesInativosCoordinates: null,
  clientesComDadosCoordinates: null,
  clientesAtivosStatus: null,
  clientesInativosStatus: null,
}
